// grantForm  service
export default {
    install: (Vue) => {
      //private
    const route = process.env.VUE_APP_API_BASE_URL + '/api/grant-applications';
  
      //public
      Vue.$grantFormService = {
        find(params) {
          return Vue.axios.get(route, {
            params: params
          });
        }
      };
    }
  };
//   //example of use
//   var grants = await Vue.$grantService.find({
//     name: 'test'
//   });